const withBuildHash = (url: string | URL, hash: string) => {
  const path = String(url)
  if (!path.startsWith('/page-data/')) {
    return url
  }
  return `${path}${path.includes('?') ? '&' : '?'}h=${hash}`
}

export const versionPageDataRequests = (hash?: string) => {
  if (!hash) {
    return
  }
  const { open } = XMLHttpRequest.prototype
  XMLHttpRequest.prototype.open = function (this: XMLHttpRequest, method: string, url: string | URL, ...rest) {
    return Reflect.apply(open, this, [method, withBuildHash(url, hash), ...rest])
  }
  const { setAttribute } = HTMLLinkElement.prototype
  HTMLLinkElement.prototype.setAttribute = function (this: HTMLLinkElement, name: string, value: string) {
    return Reflect.apply(setAttribute, this, [name, name === 'href' ? withBuildHash(value, hash) : value])
  }
}
